import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Audio/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaPerm';
import AudioTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Audio/audioTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Multimedia Menü // Audio Einstellungen",
  "path": "/Web_User_Interface/1440p_Serie/Multimedia/Audio/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Hier können Sie die Verstärkung der Kamera-Mikrofone/Audio-In als auch das Audio-Out Signal einstellen.",
  "image": "./WebUI_1440p_SearchThumb_Multimedia_Audio.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Multimedia_Audio.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Multimedia Menü // Audio Einstellungen' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Hier können Sie die Verstärkung der Kamera-Mikrofone/Audio-In als auch das Audio-Out Signal einstellen.' image='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Audio.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Audio.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Multimedia/Audio/' locationFR='/fr/Web_User_Interface/1440p_Series/Multimedia/Audio/' crumbLabel="Audio Settings" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "multimedia-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#multimedia-men%C3%BC",
        "aria-label": "multimedia menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Multimedia Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/c8814deebe62bfd523ad937dc9732e7e/aa61c/1440p_Settings_Multimedia_Audio.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.39130434782609%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAB+klEQVQoz1WRTU8TURhG+0PYNNIKbakJkaQt0/ksBNrOTOfeudMZKAWrjYqJCQkVIxiJunBh4sJEF+qOxI8lxZUb4sK/dcwUCro4ybs6eZ73yZTLZUqlEqWFBW7OZlkdvCR6c473/JTO8RnNozFrh2PWL0nv1tEp/bfn6MkBZr1GoVhiZmaGbDZLplAokFIsFsnN3qDhxiQPD1H3RqjhE+Td/f8Z7CPv7NHdfcGa2KFWWaZS0Vi6XWFxcYlMKroS5vPYpk6iAiLho4RH4DWvEH4L2fEQIkBGMe2Wi2XYmIaDaaxQq+pk5ufnmabM5XI4ToPeVp9QKYQMCYREXKKiiCjeRG3soHpDZBiwvmpg6DZ1zaZa0S6E05T5fB7HcUiSBCnlBCEEQRBMhDIMCVUXFSXI7jZx4uO3dbRlC9OwqVXr18KUqbDX6xFFESpNKcQFvkvYaRNKH3ejj7vzCKU81pw6tmnSsExqVe268r/COI4JwxClwonM9z2CrV3E/SO60V1G600eu10Gyqe9YuJYBpZpUa0sX48yrazrOp7n4bkezbaH3wnY7Er6Dw7Yevqe0f4xH5KEd9sDng37bPsNNM2YVJ78cFo3Fc7NzZEmLpdvTZaTrVUOhyG/Pr/iz/iEnz9OOPv2ia9fPvJ7/J2T1yP2EgfbsjDqF8K/U0tWy20gXT0AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c8814deebe62bfd523ad937dc9732e7e/e4706/1440p_Settings_Multimedia_Audio.avif 230w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/d1af7/1440p_Settings_Multimedia_Audio.avif 460w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/7f308/1440p_Settings_Multimedia_Audio.avif 920w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/2cb71/1440p_Settings_Multimedia_Audio.avif 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/c8814deebe62bfd523ad937dc9732e7e/a0b58/1440p_Settings_Multimedia_Audio.webp 230w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/bc10c/1440p_Settings_Multimedia_Audio.webp 460w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/966d8/1440p_Settings_Multimedia_Audio.webp 920w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/fa9eb/1440p_Settings_Multimedia_Audio.webp 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c8814deebe62bfd523ad937dc9732e7e/81c8e/1440p_Settings_Multimedia_Audio.png 230w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/08a84/1440p_Settings_Multimedia_Audio.png 460w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/c0255/1440p_Settings_Multimedia_Audio.png 920w", "/de/static/c8814deebe62bfd523ad937dc9732e7e/aa61c/1440p_Settings_Multimedia_Audio.png 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/c8814deebe62bfd523ad937dc9732e7e/c0255/1440p_Settings_Multimedia_Audio.png",
              "alt": "Web User Interface - 1440p Series - Multimedia Audio",
              "title": "Web User Interface - 1440p Series - Multimedia Audio",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <AudioTable mdxType="AudioTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      